import { Stack } from '@mui/material';
import { get, omit, pick } from 'lodash';
import LoadingSkeleton from 'src/components/common/LoadingSkeleton';
import ContactByRole from 'src/features/CompanyDetail/Contacts/ContactByRole';
import OtherContacts from 'src/features/CompanyDetail/Contacts/OtherContacts';
import { useQueryCompanyContacts } from 'src/services/queries';
import { CompanyContactPositionCode } from 'src/utils/constants/enum';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { getStringOrDefault } from 'src/utils/helpers/stringHelpers';

const ContactTable = ({ id }: { id?: string | null }) => {
  const { data, isFetching } = useQueryCompanyContacts({
    id: getStringOrDefault(id),
    refer_from: '',
  });
  const dataContacts = omit(data?.data, [CompanyContactPositionCode.Unknown, CompanyContactPositionCode.Employee]);
  const dataOtherContacts = pick(data?.data, [CompanyContactPositionCode.Unknown, CompanyContactPositionCode.Employee]);
  const listOtherContacts = Object.values(dataOtherContacts).flat();

  const getTitlePosition = (
    positionCode: Omit<
      CompanyContactPositionCode,
      CompanyContactPositionCode.Employee | CompanyContactPositionCode.Unknown
    >,
  ) => {
    switch (positionCode) {
      case CompanyContactPositionCode.Director:
        return 'Directors';
      case CompanyContactPositionCode.BeneficialOwner:
        return 'Beneficial Owner';
      case CompanyContactPositionCode.Shareholder:
        return 'Shareholder';
      case CompanyContactPositionCode.RegisteredAgent:
        return 'Registered Agent';
      default:
        return '';
    }
  };

  if (isFetching) return <LoadingSkeleton height={40} count={10} />;

  return (
    <Stack spacing={3}>
      {Object.keys(dataContacts).map(
        (
          key: Omit<
            CompanyContactPositionCode,
            CompanyContactPositionCode.Employee | CompanyContactPositionCode.Unknown
          >,
          index,
        ) => (
          <ContactByRole
            key={`compare-contacts-${index}`}
            handleOpen={() => {}}
            listContact={getArrayDefault(get(dataContacts, key.toString()))}
            title={getTitlePosition(key)}
          />
        ),
      )}
      <OtherContacts isHideActionColumn handleOpen={() => {}} listContact={getArrayDefault(listOtherContacts)} />
    </Stack>
  );
};

export default ContactTable;
